import StatsLogs from '../views/statslogs/list.vue'

export default [
  {
    path: '/statslogs',
    name: "StatsLogs",
    component: StatsLogs
  }
]